import { StoreModule } from '@ngrx/store';
import { mapDrawReducer } from './reducers/map-draw.reducer';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { MapDrawEffects } from './effects/map-draw.effects';

@NgModule({
	imports: [
		StoreModule.forFeature('mapDraw', mapDrawReducer),
		EffectsModule.forFeature([MapDrawEffects])
	]
})
export class MapDrawStoreModule {}
